import { Button, Fade, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const StyledButton = withStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    // background: '#C4C4C4 !important',
    // lineHeight: '26px',
    textDecoration: 'none',
    zIndex: 99,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: '37px',
    minWidth: 'auto',
    height: '37px',
    borderRadius: '100px',
    padding: '0px',
  },
  label: {
    fontSize: '19px',
    textTransform: 'capitalize',
    [theme.breakpoints.down('lg')]: {
      paddingRight: 'inherit',
    },
  },
}))(Button);

const useStyles = makeStyles<Theme, { isCg: boolean }>((theme) => ({
  iconTopScroll: {
    width: '36px',
    height: '36px',
    // marginRight: '8px',
    [theme.breakpoints.down('lg')]: {
      marginRight: '0px',
    },
  },
  btnPositionOverride: {
    transform: ({ isCg }) => (isCg ? 'translateY(-53px)' : 'translateY(0px)'),
  },
}));

function getScrollPercent() {
  const htmlElement = document.documentElement;
  const bodyElement = document.body;
  const scrollTop = htmlElement.scrollTop || bodyElement.scrollTop;
  const scrollHeight = htmlElement.scrollHeight || bodyElement.scrollHeight;
  const clientHeight = htmlElement.clientHeight;
  return (scrollTop / (scrollHeight - clientHeight)) * 100;
}

const showScrollTopButtonOn = 25;

function BackToTopButton({ theme }: { theme: Theme }) {
  const router = useRouter();
  const isCg = router.pathname === '/citation-generator';
  const classes = useStyles({ isCg });
  const [showTopScroolButton, setShowTopScroolButton] = useState(false);

  const onScroll = () => {
    if (getScrollPercent() > showScrollTopButtonOn) {
      setShowTopScroolButton(true);
    } else if (getScrollPercent() < showScrollTopButtonOn) {
      setShowTopScroolButton(false);
    }
  };
  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const scroolToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };
  return (
    <Fade in={showTopScroolButton}>
      <StyledButton onClick={scroolToTop} classes={{ root: classes.btnPositionOverride }}>
        <img
          src={`/images/theme/${theme.palette.mode}/landingPage/backToTopIcon.svg`}
          alt="back to top"
          className={classes.iconTopScroll}
        />
      </StyledButton>
    </Fade>
  );
}

export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(BackToTopButton);
